import smoothscroll from 'smoothscroll-polyfill';

function SmoothScroll(anchor) {

    const headerHeight = document.querySelector('.header').offsetHeight;

    // Add polfill for IE
    smoothscroll.polyfill();

    anchor.addEventListener('click', (e) => {
        e.preventDefault();

        // Fetch scrolling element
        const href = anchor.getAttribute('href');
        // Define offset for the smooth scroll
        const offsetTop = document.querySelector(href).offsetTop;

        const totalOffset = offsetTop - headerHeight;

        // Undertake the scroll to the defined element
        scroll({
            top: totalOffset,
            behavior: 'smooth'
        });
    });
}

export default SmoothScroll;